export default __webpack_public_path__ + "img/ng300.73083269.jpg";